import React from 'react';
import UsersChart from "../../../components/pages/chart/UsersChart/UsersChart";

const UsersChartPage = () => {
    return <UsersChart />
};

export default UsersChartPage;